// Components
import { SMPContainer, SMPFlex, SMPText, Table } from '../../../index';

// Types
import { INormalizedStandings, INormalizedStandingsGroup } from '../../../../types';
import { useIsSmartphoneDevice } from '../../../../hooks/useIsSmartphoneDevice';
import { Sports, TableVariants } from '../../../../constants/sportType';
import { TABULAR_WIDGET_BREAKPOINT_1 } from '../../../../constants/generic';
import { getLabelValue } from '@sportal365/smp-widget-utils';

interface IBodyProps {
  measuredRef?: (node: HTMLDivElement) => void;
  data: INormalizedStandingsGroup[];
  handleClick?: (id: string | number, name: string) => void;
  handleTeamClick?: (id: string | number, name: string) => void;
  noDataMessage?: string;
  sport?: string;
  isMobile?: boolean;
  isTeamSquad?: boolean;
  displayImage?: boolean;
  tableVariant?: TableVariants;
  containerSize?: number;
  hasPlayoff?: boolean;
}

export const Body = ({
  data,
  handleClick,
  handleTeamClick,
  noDataMessage,
  measuredRef,
  sport,
  isMobile,
  isTeamSquad,
  displayImage,
  tableVariant,
  hasPlayoff,
  containerSize,
}: IBodyProps): JSX.Element => {
  const { isMobile: isSmartphoneDevice } = useIsSmartphoneDevice();

  const getColumns = (item: INormalizedStandings) => {
    const isSmallSize = containerSize && containerSize + 16 < TABULAR_WIDGET_BREAKPOINT_1;
    const isIceHockey = sport === Sports.ICE_HOCKEY;
    const isMobileDevice = isMobile ?? isSmartphoneDevice;

    if (isIceHockey) {
      return isSmallSize ? item?.mobileColumns : item?.desktopColumns;
    }
    return isMobileDevice ? item?.mobileColumns : item?.desktopColumns;
  };

  if (tableVariant === TableVariants.STANDINGS && data?.length < 1 && !hasPlayoff) {
    return (
      <SMPContainer
        style={{
          paddingBottom: '16px',
          paddingTop: '16px',
          paddingRight: 0,
          paddingLeft: isMobile ? 0 : '$3',
          position: 'relative',
          textAlign: 'center',
          color: '$hiContrast',
        }}
        variant='paddinglessContainer'
        ref={measuredRef}
      >
        <SMPFlex>
          <SMPText variant='contrast'>{getLabelValue(noDataMessage, 'No games available')}</SMPText>
        </SMPFlex>
      </SMPContainer>
    );
  }

  return (
    <>
      {data && (
        <SMPContainer variant='paddinglessContainer' ref={measuredRef}>
          {data.map(({ name, item, position }, index) => {
            return (
              <Table
                sport={sport}
                key={index}
                groupName={name}
                columns={getColumns(item ?? ({} as INormalizedStandings))}
                rows={item?.data}
                handleClick={handleClick}
                handleTeamClick={handleTeamClick}
                noDataMessage={noDataMessage}
                isMobile={isMobile ?? isSmartphoneDevice}
                isTeamSquad={isTeamSquad}
                position={position}
                displayImage={displayImage}
                tableVariant={tableVariant}
              />
            );
          })}
        </SMPContainer>
      )}
    </>
  );
};
